function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ThunkHelper } from 'invision-core';
import ApiConstants from 'invision-core/src/api/constants';
export var UPDATE_SERVICE_LIFE_CYCLE_STATUS = {
  BEGIN: 'UPDATE_SERVICE_LIFE_CYCLE_STATUS_BEGIN',
  SUCCESS: 'UPDATE_SERVICE_LIFE_CYCLE_STATUS_SUCCESS',
  FAILURE: 'UPDATE_SERVICE_LIFE_CYCLE_STATUS_FAILURE'
};
var UPDATE_SERVICE_LIFE_CYCLE_STATUS_EVENTS = [UPDATE_SERVICE_LIFE_CYCLE_STATUS.BEGIN, UPDATE_SERVICE_LIFE_CYCLE_STATUS.SUCCESS, UPDATE_SERVICE_LIFE_CYCLE_STATUS.FAILURE];
var updateServiceLifeCycleStatusPromise = function updateServiceLifeCycleStatusPromise(dispatch, customerId, effectiveDate, nextServiceLifeCycleStatusId, reasonDescription, serviceIdentifier) {
  return ThunkHelper(dispatch, UPDATE_SERVICE_LIFE_CYCLE_STATUS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/UpdateServiceExternalLifeCycleStatus',
    data: {
      Comment: reasonDescription || undefined,
      EffectiveDate: effectiveDate,
      NextServiceLifeCycleStatusId: nextServiceLifeCycleStatusId,
      ServiceIdentifier: serviceIdentifier
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var updateServiceLifeCycleStatus = function updateServiceLifeCycleStatus(customerId, effectiveDate, nextServiceLifeCycleStatusId, reasonDescription, serviceIdentifier) {
  return function (dispatch) {
    return updateServiceLifeCycleStatusPromise(dispatch, customerId, effectiveDate, nextServiceLifeCycleStatusId, reasonDescription, serviceIdentifier);
  };
};